




export const contentPastePlaceholder = "Paste content or enter a topic to simplify";

export const uploadContentLinkLabel = "UPLOAD CONTENT (PDF, DOC, TXT)";

export const previewDocumentContent = [
  "Cell mitosis is the process by which a parent cell divides into two identical daughter cells. It includes phases such as prophase, metaphase, anaphase, and telophase, ensuring genetic material is copied and distributed evenly.",
  "Students often confuse mitosis with meiosis. Mitosis produces body cells for growth and repair, while meiosis creates gametes with half the chromosome number for sexual reproduction.",
];

export {
  familiarTopics,
  familiarTopicsHeading,
} from "../shared/familiarTopics";

export const simplificationLevelHeading = "SIMPLIFICATION LEVEL";

export const simplificationLevelOptions = [
{ id: "basic", label: "BASIC" },
{ id: "intermediate", label: "INTERMEDIATE" },
{ id: "advanced", label: "ADVANCED" }];


export const simplifyForClassLabel = "Simplify for My Class";
export const simplifyForClassHint = "Makes this easier for students to understand";

export const generatingSimplifiedContentMessage = "Simplifying content for your class…";

export const defaultContentSimplifierConfig = {
  selectedTopicId: "",
  selectedTopicLabel: "",
  simplificationLevel: "intermediate",
  visualSupport: false,
};